import { render, staticRenderFns } from "./doctor-search.vue?vue&type=template&id=4c2a01ba"
import script from "./doctor-search.vue?vue&type=script&lang=js"
export * from "./doctor-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports